import { render, staticRenderFns } from "./ResellersModal.vue?vue&type=template&id=282ef596"
import script from "./ResellersModal.vue?vue&type=script&lang=js"
export * from "./ResellersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports